import React, { lazy } from "react";
import { Route } from "react-router-dom";
const Home = lazy(() => import("../Pages/Home/Home.jsx"));
const About = lazy(() => import("../Pages/About/About.jsx"));
const Contact = lazy(() => import("../Pages/Contact/Contact"));
const Category = lazy(() => import("../Pages/Category/Category"));
const AllCourses = lazy(() => import("../Pages/All courses /AllCourses.jsx"));
const Coursedetails = lazy(() =>
  import("../Pages/Course Details/CourseDetails.jsx")
);
const ExpertDetails = lazy(() =>
  import("../Pages/Expert Details/ExpertDetails.jsx")
);
const SignUpStudent = lazy(() => import("../Pages/Sign Up/SignUpStudent.jsx"));
const SignUpexpert = lazy(() =>
  import("../Pages/Sign Up/Signupexpert/SignUpExpert.jsx")
);
const Login = lazy(() => import("../Pages/Login/Login"));

const GlobalRoutes = (
  <>
    <Route path="/" element={<Home />} />
    <Route path="/category" element={<Category />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<SignUpStudent />} />
    <Route path="/expert" element={<SignUpexpert />} />
    <Route path="/alljobs" element={<AllCourses />} />
    <Route path="/jobdetails" element={<Coursedetails />} />
    <Route path="/jobdetails/:id" element={<Coursedetails />} />
    <Route path="/expertdetails" element={<ExpertDetails />} />
  </>
);

export default GlobalRoutes;
